export default __webpack_public_path__ + "static/media/payment-paypal.734ff2fe.svg";